export const Logout = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 7V4C18 3.44772 17.5523 3 17 3H5C4.4477 3 4 3.44772 4 4V28C4 28.5523 4.4477 29 5 29H17C17.5523 29 18 28.5523 18 28V25" stroke="currentColor" stroke-width="2"/>
<path d="M11 16H27" stroke="currentColor" stroke-width="2"/>
<path d="M22.3086 10.6994L27.6006 16L22.284 21.2938" stroke="currentColor" stroke-width="2"/>
</svg>`;
